
class VariantPicker extends HTMLElement {
  inputs; product; variantId; variant; loader; lastVariant;
  static selectors = {
    loader: '[data-loader]',
    lastVariant: '[data-last-variant]',
    inputs: 'input[type="radio"]',
    lastChecked: '[data-last-variant]:checked',
    checked: 'input[type="radio"]:checked',
    json: '[data-json]'
  }

  constructor() {
    super();
    if(this.dataset.main == 'true')
      this.load();
  }

  load = () => {
    this.fetchProduct(() => this.init());
  }

  init = () => {
    this.inputs = this.querySelectorAll(VariantPicker.selectors.inputs);
    this.variantId = this.dataset.selected;
    this.setVariant();

    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.changeVariant(input);
      });
    });

    this.querySelector(VariantPicker.selectors.lastChecked).addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent(Utils.VARIANT_SELECTED_CLICKED));
    });
  }

  setVariant = () => {
    const selectedRadios = this.querySelectorAll(VariantPicker.selectors.checked);
    const selectedOptions = [];
    selectedRadios.forEach((radio) => {
      const pos = parseInt(radio.getAttribute('name').split('-')[1]);
      selectedOptions[pos] = radio.value;
    });
    this.variant = this.product.variants.filter((v) => {
      if(v.options.length == 1){
        return selectedOptions[0].localeCompare(v.option1) == 0;
      } else if(v.options.length == 2){
        return selectedOptions[0].localeCompare(v.option1) == 0 && selectedOptions[1].localeCompare(v.option2) == 0;
      } else if(v.options.length == 3){
        return selectedOptions[0].localeCompare(v.option1) == 0 && selectedOptions[1].localeCompare(v.option2) == 0 && selectedOptions[2].localeCompare(v.option3) == 0;
      }
    })[0];
    this.variantId = this.variant.id;
  }

  updateAvailabilities = () => {
    if(this.product.options.length > 1) {
      this.inputs.forEach((input) => {
        var variant = undefined;
        if(input.getAttribute('name').localeCompare('option-0') == 0){
          variant = this.product.variants.filter((v) => {
            return input.value.localeCompare(v.option1) == 0 && this.variant.option2.localeCompare(v.option2) == 0;
          })[0];
        } else {
          variant = this.product.variants.filter((v) => {
            return input.value.localeCompare(v.option2) == 0 && this.variant.option1.localeCompare(v.option1) == 0;
          })[0];
        }
  
        if(variant != undefined){
          input.disabled = !variant.available;
        }
      });
    } else if(this.product.options.length > 2) {
      this.inputs.forEach((input) => {
        var variant = undefined;
        if(input.getAttribute('name').localeCompare('option-0') == 0){
          variant = this.product.variants.filter((v) => {
            return input.value.localeCompare(v.option1) == 0 && this.variant.option2.localeCompare(v.option2) == 0 && this.variant.option3.localeCompare(v.option3) == 0;
          })[0];
        } else if(input.getAttribute('name').localeCompare('option-1') == 0){
          variant = this.product.variants.filter((v) => {
            return input.value.localeCompare(v.option2) == 0 && this.variant.option1.localeCompare(v.option1) == 0 && this.variant.option3.localeCompare(v.option3) == 0;
          })[0]; 
        } else {
          variant = this.product.variants.filter((v) => {
            return input.value.localeCompare(v.option3) == 0 && this.variant.option1.localeCompare(v.option1) == 0 && this.variant.option2.localeCompare(v.option2) == 0;
          })[0];
        }
  
        if(variant != undefined){
          input.disabled = !variant.available;
        }
      });
    }
  }

  changeVariant = (input) => {
    this.setVariant();
    this.dispatchEvent(new CustomEvent(Utils.VARIANT_CHANGED, { detail: {
      variant: this.variant,
      input: input
    }}));
  }

  fetchProduct = (callback) => {
    if(this.dataset.main == 'true')
      window.pageLoader.open();

    const jsonScript = this.querySelector(VariantPicker.selectors.json);
    if(jsonScript != undefined){
      this.product = JSON.parse(jsonScript.innerText);
      this.dispatchEvent(new CustomEvent(Utils.VARIANT_LOADED, { detail: this.variant }));
      callback();
    } else {
      axios.get(window.Shopify.routes.root + 'products/'+this.dataset.handle+'.js', {responseType: 'json'})
      .then((response) => {
        try {
          this.product = JSON.parse(response.request.responseText);
          this.dispatchEvent(new CustomEvent(Utils.VARIANT_LOADED, { detail: this.variant }));
          callback();
        } catch (e){
          Utils.error(window.lang.errors.generic, e);
        }
      })
      .catch((error) => {
        Utils.error(error.message, error);
      })
      .finally(() => {
        window.pageLoader.close();
      });
    }
  }

  getProduct = () => {
    return this.product;
  } 

}
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}